'use client'; // Error boundaries must be Client Components

import { useEffect } from 'react';

import { Header } from '@/components/header/header';
import { HeaderSection } from '@/components/header/header-section';
import { Column, Padded } from '@/components/layout/column';
import { Footer } from '@/components/layout/footer';
import { Main } from '@/components/layout/main';

import { CONSTANTS } from '../../constants';
import { sendErrorSms } from './server-actions';

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error(error);

    sendErrorSms(error.digest || error.toString() || 'Unknown error');
  }, [error]);

  return (
    <>
      <HeaderSection>
        <Header />
      </HeaderSection>
      <Main>
        <Column>
          <Padded className='flex flex-col justify-center items-center gap-4 min-h-[50vh]'>
            <div>
              A server error occurred. <br />
              digest: {error.digest}
            </div>
            <div>
              Please contact{' '}
              <a className='underline' href={`mailto:${CONSTANTS.EMAIL.SUPPORT}`}>
                {CONSTANTS.EMAIL.SUPPORT}
              </a>
            </div>
          </Padded>
        </Column>
      </Main>
      <Footer />
    </>
  );
}
